import React from 'react';
import { List, X } from 'lucide-react';

type Props = {
  open: boolean;
  onToggle: () => void;
  label: string;
  children?: React.ReactNode;
};

const MobileHamburgerNav: React.FC<Props> = ({ open, onToggle, label, children }) => (
  <div className="lg:hidden">
    <button
      type="button"
      className="inline-flex items-center gap-2 px-3 py-2 rounded-md text-sm font-semibold text-primary-700 hover:bg-primary-50"
      aria-label={open ? `Close ${label}` : `Open ${label}`}
      aria-expanded={open}
      onClick={onToggle}
    >
      {open ? <X className="h-5 w-5 shrink-0" /> : <List className="h-5 w-5 shrink-0" />}
      <span>Table of contents</span>
    </button>
    {open && children ? <div className="mt-2">{children}</div> : null}
  </div>
);

export default MobileHamburgerNav;
